module.exports = __webpack_public_path__ + "img/Togo.aadbacdd.svg";